import { ca } from '@cian/analytics';

/* Показ окна чата */
export function trackDesktopChatVisible() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Show_sopr',
    label: 'dialog',
  });
}

/* Закрытие чата по клику */
export function trackDesktopChatClose() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click_sopr',
    label: 'close_dialog',
  });
}
